import { type CollectionRule } from 'domains/collections/components/collections-form/components/rules/utils/CollectionsRules.types'
import { type ChildCollection, CollectionDatum } from 'domains/collections/types/collections.types'
import { GetCollectionQuery } from 'domains/collections/api'

export enum CollectionsFormMode {
  Create = 'create',
  View = 'view',
  Update = 'update',
}

export type CollectionsFormModeDetails =
  | {
      formMode: CollectionsFormMode.Create
      collectionId?: string
      retailerId?: string
    }
  | {
      formMode: CollectionsFormMode.Update
      collectionId: string
      retailerId?: string
    }

export type CollectionsFormModeProps = {
  formModeDetails: CollectionsFormModeDetails
}
export interface CollectionsFormData {
  showTileFragment: boolean
  showHeaderFragment: boolean
  showStorefrontBannerFragment: boolean
  details: {
    name: string
    startDate?: string
    endDate?: string
    parentId?: string
    retailerIds?: string[]
    active: boolean
    activeAdminOnly: boolean
  }
  tile: {
    image: string
  }
  header?: {
    title: string
    description?: string
    backgroundColor?: string
    color?: string
    displayStyle?: string
    mobileImage: string
    webImage: string
  }
  storefrontBanner?: {
    heading: string
    headingColor: string
    subHeading: string
    subHeadingColor: string
    cta: string
    active: boolean
    tag?: string
    tagColor?: string
    backgroundColor?: string
    bannerImage: string
  }
  rules?: CollectionRule[]
  childrenIds?: string[]
  children?: ChildCollection[]
  validation: {
    // Using any type here cause this form field does not hold data. It is a virtual field to do custom validation
    treeStructure: any
  }
}
